<template>
  <div class="truncate flex flex-col gap-2">
    <span
      v-for="field in fields"
      :key="field.name"
      class="truncate"
      :class="{'font-semibold': field.highlight}"
    >
      {{ field.value }}
    </span>
  </div>
</template>
<script>
import { trim } from 'lodash'
import { mapGetters } from 'vuex'

export default {
  props: {
    submission: {
      type: Object,
      default: () => ({}),
    },
    highlightFields: {
      type: Array,
      default: () => ['name'],
    },
  },
  computed: {
    ...mapGetters('slideSettingModule', ['selectedParticipantFields']),
    ...mapGetters('presentationSetting', ['isShownEmojiAvatar']),
    showAvatar() {
      return this.availableList?.avatar && this.isShownEmojiAvatar
    },
    legacyFields() {
      // for backward compatibility, we need to add the audience data to the list
      const nameWithAvatar = this.showAvatar
        ? `${this.submission?.audienceEmoji || ''}\u00a0\u00a0${this.submission?.audienceName || ''}`
        : this.submission?.audienceName

      return [
        {
          name: 'name',
          value: nameWithAvatar,
        },
        {
          name: 'team',
          value: this.submission?.audienceTeam,
        },
        {
          name: 'email',
          value: this.submission?.audienceEmail,
        },
      ]
    },
    availableList() {
      // all item hidden
      const map = {}
      this.selectedParticipantFields.forEach((field) => {
        map[field.type] = !field.hidden
      })

      return map
    },
    fields() {
      const allFields = [
        ...this.legacyFields,
        ...(this.submission?.participantInfo || []),
      ]

      const uniqueFields = Array.from(new Map(allFields.map((item) => [item.name, item])).values())

      return uniqueFields
        .filter((field) => this.availableList[field.name])
        .filter((field) => !!trim(field.value))
        .map((field) => {
          return {
            ...field,
            highlight: this.highlightFields.includes(field.name),
          }
        })
    },
  },
}

</script>
<style lang="scss" scoped>
.flex {
    display: flex;
}
</style>
